/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m30 3.91h-8.56v-2.91a1 1 0 0 0 -1-1h-10.18a1 1 0 0 0 -1 1v2.91h-7.26a1 1 0 0 0 0 2h2.19v25.09a1 1 0 0 0 1 1h20.4a1 1 0 0 0 1-1v-25.09h3.41a1 1 0 0 0 0-2zm-18.76-1.91h8.24v1.91h-8.24zm13.34 28h-18.44v-24.09h18.44z" }),
            React.createElement("path", { d: "m10.13 9.48a1 1 0 0 0 -1 1v14.65a1 1 0 1 0 2 0v-14.65a1 1 0 0 0 -1-1z" }),
            React.createElement("path", { d: "m15.35 9.48a1 1 0 0 0 -1 1v14.65a1 1 0 0 0 2 0v-14.65a1 1 0 0 0 -1-1z" }),
            React.createElement("path", { d: "m19.57 10.48v14.65a1 1 0 0 0 2 0v-14.65a1 1 0 0 0 -2 0z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;